/**
 * TanStack field validators built from the connection field rules (Option C, C0).
 *
 * Each validator reads the LIVE form values through `fieldApi.form` at call time — never a value captured at render —
 * so a field instance that outlived its section (TanStack keeps it after unmount and still runs it on submit) answers
 * nothing once its mode no longer applies.
 */
import type { ConnectionFormValues } from '../../components/connectionFormSchema';
import { validateFieldRule, type FieldRuleId } from './connectionFieldRules';

type ValidatorArgs = { value: unknown; fieldApi: { form: { state: { values: Partial<ConnectionFormValues> } } } };
type Validator = (args: ValidatorArgs) => string | undefined;
export type RuleValidatorCause = 'onChange' | 'onBlur' | 'onSubmit';

export function ruleValidators(field: FieldRuleId, causes: readonly RuleValidatorCause[]): Partial<Record<RuleValidatorCause, Validator>> {
  const validate: Validator = ({ value, fieldApi }) => validateFieldRule(field, value, fieldApi.form.state.values);
  return Object.fromEntries(causes.map((cause) => [cause, validate]));
}
